import { P2 } from "../../components/Paragraph";
import classNames from "classnames";
import styles from "./progressBar.module.css";

const ProgressBar = ({ progress }) => {
  return (
    <div className={styles.progressBar}>
      <div
        className={classNames(styles.progressIndicator, {
          [styles.red]: progress < 40,
          [styles.yellow]: progress >= 40 && progress < 65,
          [styles.green]: progress >= 65 && progress < 90,
          [styles.blue]: progress >= 90,
        })}
        style={{ width: `${Math.max(progress, 1)}%` }}
      />
      <div className={styles.progressCounter}>
        <P2>{`${progress}%`}</P2>
      </div>
    </div>
  );
};

export default ProgressBar;
